import './index.css';

export default {
  name: 'Aripple',
  props: {
    id: { type: String, default: () => (`a-ripple-${Math.random().toString().substring(2)}`) },
    size: { type: Number | String, default: () => 32 }, // 波纹大小
    speed: { type: Number | String, default: () => 2 }, // 滚动速度
    count: { type: Number | String, default: () => 3 }, // 波纹数量
    color: { type: String, default: () => '#FFFF00' }, // 波纹颜色
  },
  data() {
    return ({
      width: null,
      height: null,
      animationName: (`${this.id}-item`),
    });
  },
  computed: {
    array() {
      const data = [];
      for (let a = 0; a < parseInt(this.count); a++) data[a] = a;
      return data;
    },
    style() {
      return (`
        <style>
          @keyframes ${this.animationName} {
            50% { opacity: 1 }
            100% { width: ${(this.width * 1.2)}px; height: ${(this.height * 1.2)}px; opacity: 0 }
          }
        </style>
      `);
    },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        !this.width && (this.width = this.$el.clientWidth);
        !this.height && (this.height = this.$el.clientHeight);
        this.$nextTick(() => this.$el.innerHTML += this.style);
      });
    },
    revoke() {
      this.width = null;
      this.height = null;
      this.$nextTick(() => this.$el.innerHTML = null);
    },
  },
  render() {
    const { padding, margin, width = '100%', height = '100%', background } = this.$attrs;
    return this.$slots.default && (
      <div class="a-ripple" style={{ padding, margin, width, height, background }}>
        <div class="a-ripple-body">{this.$slots.default}</div>
        {this.array && this.array.length > 0 && this.array.map((a) => {
          return (
            <i
              key={a}
              class={['a-ripple-step', (`step-${(a + 1)}`)]}
              style={{
                boxShadow: (`0 0 ${parseInt(this.size)}px ${this.color}`),
                animationName: (`${this.animationName}`),
                animationDuration: (`${parseInt(this.speed)}s`),
                animationDelay: (`${(a * 0.4)}s`),
              }}
            />
          );
        })}
      </div>
    );
  }
}